import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation, Navigate } from 'react-router-dom';
import { LicenseInfo } from '@mui/x-license-pro';
import MainLayout from 'components/Layout/MainLayout';

LicenseInfo.setLicenseKey('b123764b615f0b1537e76af41f4c8c2fTz03NzU4MSxFPTE3MzAwNTg1OTUwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');

export const PrivateRoute = (children) => {
    const { userInfo } = useSelector((state) => state.auth);

    const location = useLocation();

    if (!userInfo) {
        return <Navigate to={{ pathname: '/login' }} state={{ from: location }} />;
    }

    return <MainLayout>{children}</MainLayout>;
};

PrivateRoute.prototype = {
    children: PropTypes.node
};
